import $ from 'jquery';
import _ from 'underscore';
import Moment from 'moment';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import UI from 'root/ui';
import Form from 'root/module/form';
import View from 'view/base';
import Dnd_File_Uploader from 'root/module/dnd_file_uploader';
import View_Tiptap_Editor from 'root/view/tiptap_editor';

export default View.extend({
    className: 'overlay overlay-sidebar overlay-portal',

    tags: [],
    announcement_tags: [],
    attachment: [],
    editor: null,

    events: {
        'click .close'                              : 'onClose',
        'input input[name="announcement_title"]'    : 'onInputTitle',
        'click .screenshot-attach .add'             : 'onAttachFiles',
        'click .screenshot-attach .remove'          : 'onRemoveFile',
        'keydown .dropdown-tag input[name="search"]': 'onTagSearchKeyDown',
        'keyup .dropdown-tag input[name="search"]'  : 'onTagSearchKeyUp',
        'click .dropdown-session-category li'       : 'onSelectCategory',
        'click .new-tag-add > button'               : 'onAddCategory',
        'click .action-button-toggle'               : 'onActionButtonToggle',
        'input input[name="button_text"]'           : 'onInputButtonText',
        'input input[name="button_link"]'           : 'onInputButtonLink',
        'input input[name="publish_time"]'          : 'onInputPublishTime',
        'click .publish'                            : 'onPublish',
        'click .publish-date-button'                : 'onPublishDateOpen',
        'click .save-draft'                         : 'onSaveDraft',
        'click .cancel-scheduled'                   : 'onCancelScheduled',
    },

    dom_handlers: {
        onClose: function(e) {
            this.trigger('close');
        },

        onInputTitle: function() {
            this.updateSubmitBtnStatus();
            this.updateSaveDraftBtnStatus();
        },

        onInputPublishTime: function(e) {
            var val = $(e.currentTarget).val();
            var text = val ? Moment(val).format('DD MMM YYYY h:mm a')  : '';

            this.$el.find('.publish').text(val ? 'Schedule Publish' : 'Publish Now')

            if (val) {
                this.$el.find('.publish-date-value-text').show().children('.scheduled-time').text(text);
            } else {
                this.$el.find('.publish-date-value-text').hide().children('.scheduled-time').text('');
            }
        },

        onAttachFiles: function(e) {
            Util.uploadFile(10, function(error, file_name, file_type, file_content) {
                if (error) {
                    UI.error(error);
                    return;
                }

                this.attachment = [{
                    name: file_name,
                    type: file_type,
                    content: file_content,
                }];

                this.renderAttachment();
                this.updateSubmitBtnStatus();
                this.updateSaveDraftBtnStatus();
            }.bind(this), ['image/*', 'video/mp4']);
        },

        onRemoveFile: function(e) {
            this.attachment.splice($(e.currentTarget).parent().index(), 1);
            this.renderAttachment();
            this.updateSubmitBtnStatus();
            this.updateSaveDraftBtnStatus();
        },

        onTagSearchKeyDown: function(e) {
            // Enter key
            if (e.keyCode === 13) {
                e.preventDefault();
            }
        },

        onTagSearchKeyUp: function(e) {
            var tag_name = $(e.currentTarget).val().trim();
            var exists = !tag_name || this.announcement_tags.indexOf(tag_name) !== -1;

            this.$el.find('.new-tag-add').toggle(!exists);

            if (exists) {
                return;
            } else {
                this.$el.find('.new-tag-name').text(tag_name);

                // Enter key
                if (e.keyCode === 13) {
                    this.announcement_tags.push(tag_name);
                    this.tags.push(tag_name);
                    this.renderCategories();
                    this.updateSubmitBtnStatus();
                    this.updateSaveDraftBtnStatus();
                }
            }
        },

        onSelectCategory: function(e) {
            var tag_name = $(e.currentTarget).data('val').toString();
            var index = this.tags.indexOf(tag_name);

            if (index === -1) {
                this.tags.push(tag_name);
            } else {
                this.tags.splice(index, 1);
            }

            this.renderCategories();
            this.updateSubmitBtnStatus();
            this.updateSaveDraftBtnStatus();
        },

        onAddCategory: function(e) {
            var tag_name = this.$el.find('.dropdown-tag input[name="search"]').val().trim();

            this.announcement_tags.push(tag_name);
            this.tags.push(tag_name);
            this.renderCategories();
            this.updateSubmitBtnStatus();
            this.updateSaveDraftBtnStatus();
        },

        onActionButtonToggle: function(e) {
            var on = $(e.currentTarget).hasClass('switch-on');

            $(e.currentTarget).toggleClass('switch-on switch-off');

            this.$el.find('.action-button-form').toggleClass('hidden', on);

            if (on) {
                this.$el.find('input[name="button_text"]').val('');
                this.$el.find('input[name="button_link"]').val('');
            } else {
                this.$el.find('input[name="button_text"]').focus();
            }

            this.updateSubmitBtnStatus();
            this.updateSaveDraftBtnStatus();
        },

        onPublishDateOpen: function() {
            setTimeout(() => {
                this.$el.find('.publish-date-picker').get(0).showPicker();
            }, 0);
        },

        onInputButtonText: function(e) {
            var value = $(e.currentTarget).val();

            this.$el.find('input[name="button_link"]').prop('required', !!value);
            this.updateSubmitBtnStatus();
            this.updateSaveDraftBtnStatus();
        },

        onInputButtonLink: function(e) {
            var value = $(e.currentTarget).val();

            this.$el.find('input[name="button_text"]').prop('required', !!value);
            this.updateSubmitBtnStatus();
            this.updateSaveDraftBtnStatus();
        },

        onCancelScheduled: function(e) {
            this.$el.find('.publish-date-value-text').hide().children('.scheduled-time').text('');
            this.$el.find('.publish').text('Publish Now');

            this.$el.find('input[name="publish_time"]').val('');
        },

        onSaveDraft: async function(e) {
            if (!Cache.real_user_id && !Cache.portal_user && !Cache.guest_user) {
                Modals.portalGuest();
                return;
            }

            var form_data = this.getFormData();

            this.$el.find('.save-draft').addClass('loading').prop('disabled', true);

            var action = this.model ? 'portal_announcement/update' : 'portal_announcement/add';

            if (this.model && this.model.isScheduled()) {
                form_data.publish_time = undefined;
            }

            Cache.app.request({
                action: action,
                context: this,
                data: {
                    id          : this.model ? this.model.id : undefined,
                    title       : form_data.title,
                    categories  : form_data.tags,
                    content     : form_data.content,
                    publish_time: form_data.publish_time,
                    screenshots : form_data.attachment,
                    button_text : form_data.button_text,
                    button_link : form_data.button_link,
                    is_draft    : true,
                },
                error: function() {
                    this.$el.find('.save-draft').removeClass('loading').prop('disabled', false);

                    UI.error('Couldn\'t publish announcement. Please try again later.');
                },

                success: function(response) {
                    this.updateCategoryCount();

                    if (this.model) {
                        Cache.portal_announcement.findWhere({id: response.id}).set(response);
                        UI.success('Announcement saved as draft');
                    } else {
                        Cache.portal_announcement.add(response);
                        UI.success('Announcement saved as draft');
                    }

                    this.trigger('close', {
                        announcement: response
                    });
                }
            });
        },

        onPublish: async function(e) {
            if (!Cache.real_user_id && !Cache.portal_user && !Cache.guest_user) {
                Modals.portalGuest();
                return;
            }

            var formData = this.getFormData();

            if (!formData.title) {
                this.$el.find('input[name="announcement_title"]').focus();
                return;
            }

            if (!formData.content) {
                this.$el.find('.tiptap-editor').addClass('invalid');
                return;
            }

            var is_action_button = this.$el.find('.action-button-toggle').hasClass('switch-on');

            if (is_action_button) {
                var is_valid = this.$el.find('.action-button-form input[name="button_link"]').get(0).checkValidity();

                if (!is_valid) {
                    this.$el.find('.action-button-form input[name="button_link"]').get(0).reportValidity();

                    return;
                }
            }

            this.$el.find('.tiptap-editor').removeClass('invalid');
            this.$el.find('.publish').addClass('loading').prop('disabled', true);
            var is_publish = this.$el.find('.publish').text() === 'Publish Now';

            var action = this.model ? 'portal_announcement/update' : 'portal_announcement/add';

            Cache.app.request({
                action: action,
                context: this,
                data: {
                    id          : this.model ? this.model.id : undefined,
                    title       : formData.title,
                    categories  : formData.tags,
                    content     : formData.content,
                    publish_time: formData.publish_time,
                    screenshots : formData.attachment,
                    button_text : formData.button_text,
                    button_link : formData.button_link,
                    is_draft    : false,
                },
                error: function() {
                    this.$el.find('.publish').removeClass('loading').prop('disabled', false);

                    UI.error('Couldn\'t publish announcement. Please try again later.');
                },

                success: function(response) {
                    this.updateCategoryCount();

                    if (this.model) {
                        Cache.portal_announcement.findWhere({id: response.id}).set(response);

                        if (is_publish) {
                            UI.success('Announcement published');
                        } else {
                            UI.success('Announcement scheduled for publish');
                        }
                    } else {
                        Cache.portal_announcement.add(response);

                        if (is_publish) {
                            UI.success('Announcement published');
                        } else {
                            UI.success('Announcement scheduled for publish');
                        }
                    }

                    this.trigger('close', {
                        announcement: response
                    });
                }
            });
        },
    },

    event_handlers: {
        handleFiles: function(files) {
            this.$el.find('.dnd-dropzone').hide();
            if (files.length === 0) {
                return;
            }

            for (var i = 0; i < files.length; i++) {
                if (files[i].type.indexOf('image/') === -1) {
                    continue;
                }

                Util.readFile(files[i], 10, (file_name, file_type, file_content) => {
                    if (this.attachment.length >= 1) {
                        this.$el.find('.error-msg').toggle(true);
                        return;
                    }

                    this.attachment = this.attachment.concat({name: file_name, type: file_type, content: file_content, width: 100, height: 100});
                    this.renderAttachment();
                });
            }
        },

        handleDragEnter: function() {
            this.$el.find('.dnd-dropzone').show();
        },

        handleDragLeave: function(event) {
            if (event.target === this.$el.find('.dnd-dropzone').get(0)) {
                this.$el.find('.dnd-dropzone').hide();
            }
        }
    },

    initialize: function() {
        this.tags = [];
        this.attachment = [];

        if (this.model) {
            if (this.model.get('category')) {
                this.tags = this.model.get('category').split(',');
            }

            if (this.model.get('feature_image')) {
                this.attachment = [{
                    type: 'image/unknown',
                    content: this.model.get('feature_image'),
                }];
            }

            if (this.model.get('feature_video')) {
                this.attachment = [{
                    type: 'video/unknown',
                    content: this.model.get('feature_video'),
                }];
            }
        }

        this.announcement_tags = Cache.get('announcement_categories').map((item) => {
            return item.category;
        });

        if (this.model) {
            this.announcement_tags = Util.arrayUnique([...this.announcement_tags, ...this.tags]);
        }

        this.uploader = new Dnd_File_Uploader(
            this.event_handlers.handleFiles.bind(this),
            this.event_handlers.handleDragEnter.bind(this),
            undefined,
            this.event_handlers.handleDragLeave.bind(this)
        );
    },

    focus: function() {
        this.$el.find('input[name="announcement_title"]').focus();
    },

    getFormData: function() {
        var title = this.$el.find('input[name="announcement_title"]').val().trim();
        var content = this.editor.getMarkdownContent();
        var publish_time = this.$el.find('input[name="publish_time"]').val() ? Moment(this.$el.find('input[name="publish_time"]').val()).unix() : undefined;
        var attachment = this.attachment[0];
        var button_text = this.$el.find('input[name="button_text"]').val();
        var button_link = this.$el.find('input[name="button_link"]').val();

        if (attachment && attachment.type.indexOf('unknown') !== -1) {
            attachment = {
                content: attachment.content,
            };
        }

        return {
            title: title,
            tags: this.tags,
            content: content,
            publish_time: publish_time,
            attachment: attachment,
            button_text: button_text,
            button_link: button_link,
        };
    },

    isChanged: function() {
        if (!this.model) {
            return true;
        }

        var formData = this.getFormData();

        if (formData.title !== this.model.get('title')) {
            return true;
        }

        var previous_categories = this.model.get('category') ? this.model.get('category').split(',').sort().join(',') : '';

        if (formData.tags.sort().join(',') !== previous_categories) {
            return true;
        }

        if (formData.content !== this.model.get('content')) {
            return true;
        }

        if (formData.attachment && formData.attachment.content !== this.model.get('feature_image') && formData.attachment.content !== this.model.get('feature_video')) {
            return true;
        }

        if (formData.button_text !== (this.model.get('button_text') || '')) {
            return true;
        }

        if (formData.button_link !== (this.model.get('button_link') || '')) {
            return true;
        }

        return false;
    },

    updateSaveDraftBtnStatus: function() {
        var form_data = this.getFormData();
        var is_changed = this.isChanged();
        var is_scheduled = this.model ? this.model.isScheduled() : false;
        var is_draft = this.model ? this.model.get('is_draft') : false;
        var filled = !!form_data.title && !!form_data.content;

        if (!this.model) {
            if (filled) {
                this.$el.find('.save-draft').removeClass('disabled').prop('disabled', false);
                return;
            }

            this.$el.find('.save-draft').addClass('disabled').prop('disabled', true);
            return;
        }

        if (is_draft) {
            if (filled && is_changed) {
                this.$el.find('.save-draft').removeClass('disabled').prop('disabled', false);
                return;
            }

            this.$el.find('.save-draft').addClass('disabled').prop('disabled', true);
            return;
        }

        if (is_scheduled) {
            this.$el.find('.save-draft').removeClass('disabled').prop('disabled', false);
            return;
        }

        this.$el.find('.save-draft').removeClass('disabled').prop('disabled', false);
    },

    updateSubmitBtnStatus: function() {
        var form_data = this.getFormData();
        var can_publish = true;
        var is_action_button = this.$el.find('.action-button-toggle').hasClass('switch-on');

        if (!form_data.title || !form_data.content) {
            can_publish = false;
        } else if (is_action_button && (!form_data.button_text || !form_data.button_link)) {
            can_publish = false;
        }

        this.$el.find('.publish').toggleClass('disabled', !can_publish).prop('disabled', !can_publish);
        this.$el.find('.publish-date-button').toggleClass('disabled', !can_publish).prop('disabled', !can_publish);
    },

    updateCategoryCount: function() {
        var announcement_tags = Cache.get('announcement_categories').map((item) => {
            return item.category;
        });
        var original_tags = this.model
            ? this.model.get('category').split(',')
            : [];
        var new_tags = this.tags.filter((item) => {
            return announcement_tags.indexOf(item) === -1;
        });
        var added_tags = this.tags.filter((item) => {
            return (
                original_tags.indexOf(item) === -1 &&
                announcement_tags.indexOf(item) !== -1
            );
        });
        var deleted_tags = original_tags.filter((item) => {
            return this.tags.indexOf(item) === -1;
        });

        var next_announcement_tags = Cache.get('announcement_categories')
            .map((item) => {
                if (deleted_tags.includes(item.category)) {
                    return {
                        category: item.category,
                        count: item.count - 1,
                    };
                }

                if (added_tags.includes(item.category)) {
                    return {
                        category: item.category,
                        count: item.count + 1,
                    };
                }

                return item;
            })
            .filter((item) => {
                return item.count > 0;
            })
            .concat(
                new_tags.map((item) => {
                    return {
                        category: item,
                        count: 1,
                    };
                })
            );

        Cache.add('announcement_categories', next_announcement_tags);
    },

    renderCategories: function() {
        var tags_selected = '';
        var tag_options   = '';

        this.tags.forEach(function(tag_name) {
            tags_selected +=
            '<span class="badge-primary-invert badge-small font-weight-medium">' + Util.htmlEntities(tag_name) + '</span>';
        });

        this.announcement_tags.forEach(function(tag_name) {
            tag_options += '<li data-val="' + tag_name + '"' + (this.tags.indexOf(tag_name) === -1 ? '' : ' class="selected"') + '>' + tag_name + '</li>';
        }, this);

        var content = '';

        content += '<div class="button-dropdown button-dropdown-full button-dropdown-up">' +
                        '<button type="button" class="dropdown-button dropdown-select dropdown-select-medium dropdown-select-multiple">' +
                            (tags_selected || '<span class="placeholder-text">Select...</span>') +
                        '</button>' +
                        '<div class="dropdown-tag-select">' +
                            '<div class="dropdown-search">' +
                                '<input name="search" type="text" class="solid compact" maxlength="20" placeholder="Add tag...">' +
                            '</div>' +
                            '<ul class="dropdown dropdown-session-category' + (tag_options ? ' dropdown-select' : '') + '" data-empty="No tags found">' +
                                (tag_options || '<li class="disabled">No tags added</li>') +
                            '</ul>' +
                            '<div class="new-tag-add" style="display:none;">' +
                                '<button type="button" class="text-link small"><i class="fa-solid fa-plus margin-right-4"></i>Create new tag: <span class="new-tag-name"></span></button>' +
                            '</div>' +
                        '</div>' +
                    '</div>';

        this.$el.find('.dropdown-tag').html(content);
    },

    renderAttachment: function() {
        this.$el.find('.screenshot-attach .preview > div').remove();

        this.attachment.forEach(function(file_info) {
            if (file_info.type.startsWith('image/')) {
                $('<div>')
                    .css('background-image', 'url("' + file_info.content + '")')
                    .html('<button class="remove" type="button"><i class="fas fa-times-circle"></i></button>')
                    .appendTo(this.$el.find('.screenshot-attach .preview'));
            } else if (file_info.type.startsWith('video/')) {
                $('<div>')
                    .html('<video src="' + file_info.content + '"></video><button class="remove" type="button"><i class="fas fa-times-circle"></i></button>')
                    .appendTo(this.$el.find('.screenshot-attach .preview'));
            }
        }.bind(this));

        this.$el.find('.screenshot-attach .add').toggle(this.attachment.length < 1);
        this.$el.find('.error-msg').toggle(this.attachment.length > 1);
    },

    renderTextEditor: function() {
        this.editor = new View_Tiptap_Editor({
            default_content: this.model ? this.model.get('content') : '',
        });

        this.editor.render().$el.appendTo(this.$el.find('.announcement-editor'));

        this.editor.on('update', () => {
            this.updateSaveDraftBtnStatus();
            this.updateSubmitBtnStatus();
        });
    },

    render: function() {
        var content = '';

        content +=
        '<div class="portal-announcement-details portal-announcement-details-small">' +
            '<button type="button" class="close btn-close">' +
                '<i class="fa-regular fa-xmark"></i>' +
            '</button>' +
            '<div class="portal-new-announcement">' +
                '<div class="new-announcement-heading">' +
                    '<h2>' + (this.model ? 'Update' : 'New') + ' Announcement</h2>' +
                '</div>' +
                '<div class="new-announcement-body">' +
                    '<form class="announcement-form form-fluid">' +
                        '<div class="row">' +
                            '<div class="field-label">Title</div>' +
                            '<input type="text" class="solid medium" name="announcement_title" placeholder="Announcement title" maxlength="100" required>' +
                        '</div>' +
                        '<div class="row">' +
                            '<div class="field-label">Featured Image / Video</div>' +
                            '<div class="screenshot-attach">' +
                                '<div class="preview"></div>' +
                                '<div class="add">' +
                                    '<div>' +
                                        '<span><i class="far fa-image"></i></span>' +
                                        '<span><i class="far fa-plus"></i></span>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                            '<div class="image-help">Recommended image width: 420px, video format: .mp4</div>' +
                            '<div class="error-msg">You may only attach a maximum of 1 image</div>' +
                        '</div>' +
                        '<div class="row">' +
                            '<div class="field-label">Announcement</div>' +
                            '<div class="announcement-editor"></div>' +
                        '</div>' +
                        '<div class="row">' +
                            '<div class="field-label">Tags</div>' +
                            '<div class="dropdown-tag"></div>' +
                        '</div>' +
                        '<div class="row action-button">' +
                            '<div class="flex-start">' +
                                '<div class="field-label">Action Button</div>' +
                                '<button type="button" class="margin-bottom-8 margin-left-8 action-button-toggle switch-off small"></button>' +
                            '</div>' +
                            '<div class="grid-4-8 grid-gap-8 action-button-form hidden">' +
                                '<input type="text" class="solid medium margin-bottom-8" name="button_text" placeholder="Button text" maxlength="100" required>' +
                                '<input type="url" class="solid medium margin-bottom-8" name="button_link"placeholder="https://www.example.com" required>' +
                            '</div>' +
                        '</div>' +
                    '</form>' +
                '</div>' +
                '<div class="new-announcement-footer flex-between">' +
                    '<button type="button" class="save-draft tertiary square medium margin-right-8" disabled>Save as draft</button>' +
                    '<div class="flex-start">' +
                        '<div class="publish-date-value-text margin-right-8">' +
                            '<i class="fa-regular fa-clock margin-right-4 text-icon"></i>Scheduled for <span class="scheduled-time"></span>' +
                            '<div class="flex-end"><span class="cancel-scheduled">Cancel</span></div>' +
                        '</div>' +
                        '<div class="button-group button-group-submit" data-autohighlight="false">' +
                            '<button type="button" class="publish primary" disabled>Publish Now</button>' +
                            '<button type="button" class="primary publish-date-button tooltip" data-title="Schedule publish" disabled>' +
                                '<i class="fa-regular fa-clock"></i>' +
                                '<input type="datetime-local" class="publish-date-picker" name="publish_time">' +
                            '</button>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="dnd-dropzone" data-size="large" data-theme="light" style="display:none"></div>' +
        '</div>';

        this.$el.html(content);

        if (this.model) {
            var publish_time = Moment(this.model.get('publish_time') * 1000);
            var is_scheduled = this.model.isScheduled();

            Form.setData(this.$el, {
                announcement_title: this.model.get('title'),
                button_text: this.model.get('button_text'),
                button_link: this.model.get('button_link'),
            });

            if (this.model.get('button_text')) {
                this.$el.find('.action-button-toggle').removeClass('switch-off').addClass('switch-on');
                this.$el.find('.action-button-form').removeClass('hidden');
            }

            if (is_scheduled) {
                this.$el.find('input[name="publish_time"]').val(publish_time.format('YYYY-MM-DDTHH:mm'));
                this.$el.find('.publish-date-value-text').children('.scheduled-time').text(publish_time.format('DD MMM YYYY h:mm a'));
                this.$el.find('.publish').text('Save');
            } else {
                this.$el.find('.publish-date-value-text').hide();
            }
        } else {
            this.$el.find('.publish-date-value-text').hide();
        }

        this.uploader.setupDropArea(this.$el.find('.portal-announcement-details').get(0));

        this.renderCategories();
        this.renderAttachment();
        this.renderTextEditor();

        this.updateSubmitBtnStatus();
        this.updateSaveDraftBtnStatus();

        return this;
    }
});